import React from 'react';

type RadioGroupProviderValue = {
  checkedValue?: string;
  groupIsDisabled?: boolean;
  onPressRadio: (value: string) => void;
};

export const RadioGroupProvider = React.createContext<RadioGroupProviderValue>({ onPressRadio: () => null });
